import { render, staticRenderFns } from "./pagoPredial.vue?vue&type=template&id=5a4e140e&scoped=true&"
import script from "./pagoPredial.vue?vue&type=script&lang=js&"
export * from "./pagoPredial.vue?vue&type=script&lang=js&"
import style0 from "./pagoPredial.vue?vue&type=style&index=0&id=5a4e140e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e140e",
  null
  
)

export default component.exports